import React, { FC } from 'react';
import { IntlProvider } from 'react-intl';
import languageDa from '../translations/da.json';
import languageEn from '../translations/en.json';
import { useLanguage } from '../hooks';

const lokales = {
    en: languageEn,
    da: languageDa,
};

/**
 * Providers the Language formatter and lokalization to all consumers
 * @returns
 */
export const LanguageProvider: FC = ({ children }) => {
    const language = useLanguage();

    return (
        <IntlProvider locale={language} messages={lokales[language]}>
            {children}
        </IntlProvider>
    );
};
